import { formatInTimeZone } from "date-fns-tz";

/**
 * Renders a true-UTC API datetime as wall-clock time in `timeZone`, without a
 * `Z` suffix — the shape `createMapLink` and the `/map` query params expect.
 * Counterpart to `formatApiDatetime`, which goes the other way.
 */
export const utcToWallClock = (utcDatetime: string, timeZone: string): string =>
  formatInTimeZone(utcDatetime, timeZone, "yyyy-MM-dd'T'HH:mm:ss");
